// extracted by mini-css-extract-plugin
module.exports = {"articleBodyContent":"ArticleBodyText_articleBodyContent__17wqE","sectionBreak":"ArticleBodyText_sectionBreak__1UiFp"};